import api from '../../plugins/api';

// POST /api/crm/vin-blacklist/delete/{id} â ÑÐ±ÑÐ°ÑÑ Ð·Ð°Ð¿Ð¸ÑÑ Ð¸Ð· ÑÐ¿Ð¸ÑÐºÐ°.
const deleteVinFromBlacklist = (id) => {
  return api.post(`/api/crm/vin-blacklist/delete/${id}`);
};

export default deleteVinFromBlacklist;
